import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable'; 
import { formatNumber } from '../../utils/param-utils'; // Added import for formatNumber
import { useBranding } from '../../utils/branding';

export const generateBatchTransactionReport = (data) => {
  const batch = data.data.batch;
  const statistic = data.data.statistics;
  const doc = new jsPDF();
  
  const { brandLogo, brandName } = useBranding();

  doc.setProperties({
    title: "Batch Transaction Report",
    creator: brandName
  });

  const pageWidth = doc.internal.pageSize.width;
  const margin = 20;

  const logoUrl = brandLogo;
  const logoWidth = 30;
  const logoHeight = 10;
  doc.addImage(logoUrl, "PNG", pageWidth - margin - logoWidth, margin, logoWidth, logoHeight);

  // Title
  doc.setFontSize(16);
  doc.setFont("IBM Plex Sans Devanagari", 'bold');
  doc.text("Batch Transaction Report", margin, margin + 5);

  doc.setFillColor(244, 246, 246);
  doc.roundedRect(20, 45, 170, 50, 3, 3, 'F'); 

  doc.setFont("IBM Plex Sans Devanagari", 'light');
  doc.setTextColor('#128050');
  doc.setFontSize(12);
  doc.text("SUMMARY", 25, 53);

  // ini sumarry yaaa
  doc.setTextColor('#000000');
  doc.setFontSize(12);
  doc.setFont('IBM Plex Sans Devanagari', 'light');
  doc.text("Batch ID", 25, 63);
  doc.text('Date & Time', 60, 63);
  doc.text('Company Name', 100, 63);
  doc.text('Total Transaction', 25, 78);
  doc.text('Success', 60, 78);
  doc.text('Failed', 75, 78);
  doc.text('Total Amount (include admin fee)', 100, 78);
  doc.setFont('IBM Plex Sans Devanagari', 'bold');
  doc.text(batch.batch_id, 25, 68);
  doc.text(batch.batch_datetime, 60, 68);
  doc.text('Jawa Jawa Jawa', 100, 68);
  doc.text(String(batch.total_recipient), 25, 83);
  doc.text(String(statistic.success_count), 60, 83);
  doc.text(String(statistic.failed_count), 75, 83);
  doc.text("IDR " + formatNumber(batch.grand_total_amount), 100, 83); // Updated to use formatNumber

  // ini transaction listt nyaaa
  doc.setFont("IBM Plex Sans Devanagari", 'light');
  doc.setTextColor('#128050');
  doc.setFontSize(12);
  doc.text("TRANSACTION LIST", 15, 110);

  const headers = ["Transaction ID", "Amount", "Admin Fee", "Bank", "Account Number", "Account Name", "Status"];

  const transactions = batch.transactions || [];
  const tableData = transactions.map((transaction) => [
    transaction.transaction_id || "-",
    "IDR " + formatNumber(transaction.amount || 0), // Updated to use formatNumber
    "IDR " + formatNumber(transaction.admin_fee || 0), // Updated to use formatNumber
    transaction.bank || "-",
    transaction.account_number || "-",
    transaction.account_name || "-",
    {
      content: transaction.status === "Success" ? "Success" : "Failed",
      styles: {
        textColor: transaction.status === "Success" ? [18, 128, 80] : [255, 0, 0],
        fontStyle: 'bold',
        halign: 'left',
        fillColor: transaction.status === "Success" ? [240, 255, 240] : [255, 240, 240],
        cellPadding: 2
      },
      drawCell: (cell) => {
        const { x, y, width, height } = cell;
        doc.setDrawColor(0, 0, 0);
        doc.roundedRect(x, y, width, height, 2, 2, 'S');
      }
    }
  ]);

  autoTable(doc, {
    startY: 115,
    head: [headers],
    body: tableData,
    theme: 'grid',
    headStyles: {
      font: "IBM Plex Sans Devanagari",
      fillColor: false,
      textColor: [0, 0, 0, 0.7],
      fontSize: 10,
      lineWidth: 0.1,
      lineColor: [234, 236, 240]
    },
    bodyStyles: {
      font: "IBM Plex Sans Devanagari",
      fontSize: 9,
      lineWidth: 0.1, 
      lineColor: [234, 236, 240],
      borderStyle: 'solid',
      borderTop: true,
      borderBottom: true,
      borderLeft: false,
      borderRight: false 
    },
    columnStyles: {
      6: {
        halign: 'center'
      }
    },
    margin: { left: margin - 10, right: margin - 10 }
  });

  doc.setFillColor(244, 246, 246); 
  doc.rect(0, 287, 210, 10, 'F');
  doc.setFontSize(12);
  doc.setTextColor('#6c757d');
  doc.text("© PT Anugrah Multi Remittance 2025. All rights reserved.", 105, 293, { align: "center" });

  doc.save(`Batch_${batch.batch_id || "Batch123456"}_Report.pdf`);
};

export default {
  generateBatchTransactionReport
};